import { LayerTypeId, MapGeometryType } from "@omnia/shared/generated/enums";
import { FieldViewModel, IComponentLauncher, IDataLayer, IDatalayerEditModel, SharedLayersService } from "../exports";
import { ISeedRatePlan, ISeedsService } from "../types";
import { LayerEditorConfig as BaseLayerEditorConfig } from "../exports";

interface LayerEditorConfig extends BaseLayerEditorConfig {
    planName: string
}

export class DrawSeedMapCmd {

    targetPlan: ISeedRatePlan;

    execute: (target: any) => void

    constructor(
        private readonly launcher: IComponentLauncher,
        private readonly svc: ISeedsService,
        private readonly layerSvc: SharedLayersService,
        public text: string,
        public icon: string,
        private readonly layerType = svc.getSeedLayerType()) {

    }

    drawSeedsMap(plan: ISeedRatePlan, cropping: FieldViewModel, layer: IDataLayer) {

        const newLayer = !layer

        if (newLayer) {

            layer = <IDataLayer>{

                DataLayerId: 0,

                TypeId: LayerTypeId.SeedRate,
                Type: this.layerType,
                GeometryType: MapGeometryType.Polygon,

                FieldId: cropping.cropping.FieldId,
                CroppingId: cropping.cropping.CroppingId,

                Zones: []
            };

        }

        this.targetPlan = plan;

        const config: LayerEditorConfig = {

            canEditFeatures: layer?.GeometryType != MapGeometryType.Grid,
            title: newLayer ? 'Draw a seed rates map' : 'Edit a seed rates map',

            canChangeLayerType: false,
            availableLayerTypes: [this.layerType],

            headerTemplateUrl: "app/seeds/drawSeedMap/header.html",

            planName: plan.Name,

            saveChanges: m => this.saveChanges(m, cropping)

        }

        const args = {
            layer,
            field: cropping,
            config
        }

        return this.layerSvc.startLayerEditor(args, this.launcher)

    }

    saveChanges(target: IDatalayerEditModel, cropping: FieldViewModel) {

        const { targetPlan, svc } = this

        const seedmap = targetPlan.Maps.find(m => m.CroppingId == cropping.croppingId)

        return svc.drawSeedRatesMap(targetPlan.SeedRatePlanId, seedmap.SeedRateMapId, target)
            .then(layer => svc.refresh().then(() => {
                    svc.setLayerVisibility(layer.DataLayerId, true)
                    return layer
                })
            )

    }



}
